import { Heading, Text } from '@soteria/design-system-ve';
import { useMemo } from 'react';

import { DataList } from '../../../core/components';
import type { TableColumn } from '../../../core/components/DataList';
import type { PolicyMetrics } from '../../domain/audit-report-types';
import * as reportStyles from '../../pages/AuditReportPage.css';

interface PolicyMetricsSectionProps {
  policyMetrics: PolicyMetrics[];
}

export function PolicyMetricsSection({ policyMetrics }: PolicyMetricsSectionProps) {
  const columns: TableColumn<PolicyMetrics>[] = useMemo(
    () => [
      {
        key: 'policyName',
        header: 'Policy Name',
        render: (item: PolicyMetrics) => <Text>{item.policyName}</Text>,
        width: '30%',
      },
      {
        key: 'triggeredCorrectness',
        header: 'Triggered Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.triggeredCorrectnessCount} ({(item.triggeredCorrectnessPercentage * 100).toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
      {
        key: 'nonTriggeredCorrectness',
        header: 'Non-Triggered Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.nonTriggeredCorrectnessCount} ({(item.nonTriggeredCorrectnessPercentage * 100).toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
      {
        key: 'overallCorrectness',
        header: 'Overall Correct',
        render: (item: PolicyMetrics) => (
          <Text>
            {item.overallCorrectnessCount} ({(item.overallCorrectnessPercentage * 100).toFixed(1)}%)
          </Text>
        ),
        width: '23.33%',
      },
    ],
    []
  );

  return (
    <div>
      <Heading level="h4">Policy Performance Assessment</Heading>
      <div className={reportStyles.labelPerformanceSection}>
        <DataList hideEmptyState columns={columns} data={policyMetrics} dataTypeName="policy metric" emptyStateMessage="No policy metrics available." />
      </div>
    </div>
  );
}
